import React, {Component} from 'react';
import {Input} from 'reactstrap';
import {connect} from 'react-redux';

import storeDataFunc from './dropdownStore';

class LoadingOption extends Component {
    state = {
        loadEnder: false,
    }

    componentDidMount() {
        this.setState({
            loadEnder: true
        })
    }
    
    selectTextFunc() {
        let numberOfCredits = 0
            if(this.props.value.formElement.elementConfig.selectText !== undefined){
               

                for (let i = 0; i < this.props.value.formElement.elementConfig.creditsData.length; i++) {
                    const val = this.props.value.formElement.elementConfig.creditsData[i];
                    if(val[this.props.value.data.creditsDataId] == this.props.value.value && numberOfCredits === 0){
                        numberOfCredits++ 
                        return  <div style={{position: 'absolute', marginTop: 20}}>
                                    <p id="selectText">{val[this.props.value.formElement.elementConfig.selectText] !== undefined && val[this.props.value.formElement.elementConfig.selectText]}</p>
                                </div>
                    }
                }
                return  <div style={{position: 'absolute', marginTop: 20}}>
                            <p id="selectText">{0}</p>
                        </div>
            }
    }

    render() {
        let data = [];
        const {storeKey} = this.props.value.data;

        data = storeDataFunc(this.props, data, storeKey);

        
        return (
            <div>
                {
                    <Input 
                        className={this.props.className}
                        type={this.props.type}
                        name={this.props.name}
                        id={this.props.id}
                        value={this.props.value.value}
                        onChange={this.props.onChange}
                    >
                    {
                        this.state.loadEnder ?
                            <option attr-key={this.props.value.data ? this.props.value.data.name : null}>Choose an Option...</option>
                            :
                            <option>loading...</option>
                    }
                   
                    {
                    this.props.hardCodeSelects === undefined ?                        
                        data !== '' &&
                            this.props.value.data.storeKey !== false && data.length !== 0 &&
                            data.map(val => {
                                if(val.id !== undefined ) {
                                    return (
                                        <option attr-key={this.props.value.data.name} value={val.id}>{val[this.props.value.data.name]}</option>
                                    )
                                }else {
                                    return (
                                        <option attr-key={this.props.value.data.name} value={val[this.props.value.data.id]}>{val[this.props.value.data.name]}</option>
                                    )
                                }
                            })
                        :
                            this.props.hardCodeSelects.map(val => {
                                return (
                                    <option value={val.id}>{val.value}</option>
                                )
                            })
                    }
                    </Input>
                }
                    <div>
                        {
                            this.props.value.formElement.elementConfig.selectText !== undefined && 
                                this.selectTextFunc()
                        }
                    </div>
            </div>
        )
    }
}

const mapStateToProps = state => state

export default connect(mapStateToProps)(LoadingOption)


// WEBPACK FOOTER //
// ./src/_components/common/Form2/LoadingOption.jsx